import classNames from 'classnames'
import React from 'react'
import { IBaseProps } from 'browser/components/atomic-elements/atoms/base-props'
import { HelpBlock } from 'browser/components/atomic-elements/atoms/help-block/help-block'
import { renderEventTimestamp } from '../util'
import { EventChanges } from '../workflow-events/event-changes'
import { EventChangeSetList } from './event-change-set-list'

interface IChangeSetItemProps extends IBaseProps {
  entity: any
  item: any
  isFirst: boolean
  isLast: boolean
  showEdgeActivity?: boolean
}

export class ChangeSetItem extends React.Component<IChangeSetItemProps, any> {
  public render() {
    const { className, item, entity, isFirst, showEdgeActivity } = this.props
    const { changeSet, creationDate } = item
    const { author } = changeSet

    return (
      <div className={classNames('c-timelineEvent', className)} key={item.uniqueId}>
        <div
          className={classNames('c-timelineEvent-line', className, {
            'c-timelineEvent-line--topCutOff': isFirst,
          })}
        />
        <div className="c-timelineEvent-dot" />
        <div className="c-timelineEvent-contentContainer">
          <div className="c-timelineEvent-body">
            <HelpBlock>
              <span className="b">{author.displayName}</span> updated on{' '}
              {renderEventTimestamp(creationDate)}:<br />
              <EventChanges>
                <EventChangeSetList
                  entity={entity}
                  changeSet={changeSet}
                  showEdgeActivity={showEdgeActivity}
                />
              </EventChanges>
            </HelpBlock>
          </div>
        </div>
      </div>
    )
  }
}
